import { lazy } from 'react'
import { type RouteObject } from 'react-router-dom'

const WmsDashboardPage = lazy(() => import('./pages/dashboard'))

const generalRoutes: RouteObject[] = [
  {
    path: 'general',
    children: [
      {
        path: 'dashboard',
        element: <WmsDashboardPage />
      }
    ]
  }
]

export default generalRoutes
